import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Features from "@/components/Features";
import HowItWorks from "@/components/HowItWorks";
import { GatewaySection } from "@/components/GatewayConsole";
import Pricing from "@/components/Pricing";
import Roadmap from "@/components/Roadmap";
import { scrollToTarget } from "@/lib/scroll";

export default function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToTarget(hash), 100);
      return () => clearTimeout(t);
    }
  }, [hash]);

  return (
    <main>
      <Hero />
      <Marquee />
      <Features />
      <HowItWorks />
      <GatewaySection />
      <Pricing />
      <Roadmap />
    </main>
  );
}
